import {
  ConversationDetails,
  ConversationMessage,
} from '@/types/conversationMessage';
import api from '@/api';

const CONVERSATIONS_PATH = 'conversations';
const DEFAULT_PER_PAGE = 25;
const DEFAULT_DIRECTION = 'backwards';
const DEFAULT_INCLUDES = [
  'sender',
  'message_attachments',
  'negotiation_snapshot',
  'negotiation_snapshot.brand_negotiation.contract',
  'negotiation_snapshot.gig_deliverable_changes',
];

type FetchMessagesParams = {
  conversationId: string;
  cursor?: string;
  direction?: 'backwards' | 'forwards';
  perPage?: number;
};

const conversationsFetchers = {
  messages: async (
    params: FetchMessagesParams
  ): Promise<ConversationMessage[]> => {
    const {
      conversationId,
      cursor,
      direction = DEFAULT_DIRECTION,
      perPage = DEFAULT_PER_PAGE,
    } = params;

    const result = await api.get(
      `${CONVERSATIONS_PATH}/${conversationId}/messages`,
      {
        params: {
          cursor,
          direction,
          per_page: perPage,
          include: DEFAULT_INCLUDES,
        },
      }
    );

    return result.data as ConversationMessage[];
  },

  conversationDetails: async (
    conversationId: string,
    brandId: string
  ): Promise<ConversationDetails> => {
    const result = await api.get(`${CONVERSATIONS_PATH}/${conversationId}`, {
      params: {
        brand_id: brandId,
        campaign_summary_type: 'separate',
        include: [
          'campaign_conversations',
          'campaign_conversations.campaign',
          'first_unread_message',
        ],
      },
    });
    const data = result.data as ConversationDetails;
    return {
      id: data.id,
      firstUnreadMessage: data.firstUnreadMessage ?? null,
      unreadMessagesCount: data.unreadMessagesCount ?? 0,
      campaignConversations: data.campaignConversations ?? [],
    };
  },

  campaignConversationMessages: async (
    campaignConversationId: string
  ): Promise<ConversationMessage[]> => {
    const result = await api.get(
      `${CONVERSATIONS_PATH}/${campaignConversationId}/messages`,
      {
        params: {
          include: DEFAULT_INCLUDES,
        },
      }
    );
    return result.data as ConversationMessage[];
  },
};

export default conversationsFetchers;
